import React from 'react';

import {Skeleton, Stack} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';

export const ProtocolDetailLoading = () => {
	const {isMobile} = useMediaQueries();

	return (
		<Stack gap={2} px={2} pt={isMobile ? 0 : 2} pb={4} flex={1}>
			<Skeleton variant="rectangular" width="100%" height={26} />

			<Stack gap={1}>
				<Skeleton variant="rectangular" width="40%" height={18} />
				<Skeleton variant="rectangular" width="27%" height={18} />
			</Stack>

			<Stack gap={1} mb={2}>
				<Skeleton variant="rectangular" width="58%" height={18} />
				<Skeleton variant="rectangular" width="40%" height={18} />
			</Stack>

			<Stack gap={1}>
				<Skeleton variant="rectangular" width="58%" height={18} />
				<Skeleton variant="rectangular" width="40%" height={18} />
			</Stack>
		</Stack>
	);
};
